import { Component, inject, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { Legend } from '@app/features/lobby/consts/legend.constants';
import { ButtonComponent } from '@app/components/button/button.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-lobby-dialog-legends',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonComponent, AngularSvgIconModule],
  templateUrl: './lobby-dialog-legends.component.html',
  styleUrls: ['./lobby-dialog-legends.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'dialog app-lobby-dialog-legends' }
})
export class LobbyDialogLegendsComponent extends DialogBase {
  dialogData = inject(DIALOG_DATA) as { gameLegend: any[], otherLegend: any[] };
  showOtherLegendInfo = false;
}
